import FarloUiRevolverCarousel from './farlo-ui-revolver-carousel.js';

class FarloUiLightbox {
  constructor(element, options = {}) {
    this.element = element;
    this.options = options;
    this.carouselEnabled = Boolean(element.closest('.farlo-ui-revolver-carousel--enabled'));
    this.currentCarouselIndex = 0;

    // Carousel vs single‐item trigger
    if (this.carouselEnabled) {
      Array.from(this.element.children).forEach((item, idx) =>
        item.addEventListener('click', e => {
          e.preventDefault();
          this.currentCarouselIndex = idx;
          this.openLightbox();
        })
      );
    } else {
      this.element.addEventListener('click', e => {
        e.preventDefault();
        this.openLightbox();
      });
    }

    this.initialiseLightboxContainer();

    // grab all pieces
    this.lightbox = document.querySelector('.farlo-ui-lightbox');
    this.lightbox.setAttribute('tabindex', '-1');
    this.lightboxContentWrapper = this.lightbox.querySelector('.farlo-ui-lightbox__content');
    this.lightboxContentInner   = this.lightbox.querySelector('.farlo-ui-lightbox__content-inner');
    this.closeButton             = this.lightbox.querySelector('.farlo-ui-lightbox__close');
    this.backdrop                = this.lightbox.querySelector('.farlo-ui-lightbox__backdrop');

    // close controls
    this.closeButton.addEventListener('click', this.closeLightbox.bind(this));
    this.backdrop.addEventListener('click', this.closeLightbox.bind(this));
    this.lightbox.addEventListener('click', this.onClickOutside.bind(this));

    // global Esc
    this.handleKeydownBound = this.handleKeydown.bind(this);
    window.addEventListener('keydown', this.handleKeydownBound);

    // ARIA
    this.element.setAttribute('aria-haspopup', 'dialog');
    this.lightbox.setAttribute('role', 'dialog');
    this.lightbox.setAttribute('aria-modal', 'true');
    this.closeButton.setAttribute('aria-label', 'Close Lightbox');
  }

  initialiseLightboxContainer() {
    // only build once, if triggers exist
    const triggers = document.querySelectorAll('.site-video-embed-group, .farlo-ui-lightbox__toggle, .wp-block-gallery');
    if (triggers.length > 0 && !document.querySelector('.farlo-ui-lightbox')) {
      const container = document.createElement('div');
      container.className = 'farlo-ui-lightbox';

      const inner          = document.createElement('div');
      inner.className      = 'farlo-ui-lightbox__inner';

      // this is what footer.js is querying
      const contentWrapper = document.createElement('div');
      contentWrapper.className = 'farlo-ui-lightbox__content';

      const contentInner = document.createElement('div');
      contentInner.className = 'farlo-ui-lightbox__content-inner';

      const btnClose = document.createElement('button');
      btnClose.className = 'farlo-ui-lightbox__close';

      const backdrop = document.createElement('div');
      backdrop.className = 'farlo-ui-lightbox__backdrop';

      contentWrapper.appendChild(contentInner);
      contentWrapper.appendChild(btnClose);
      inner.appendChild(contentWrapper);
      container.appendChild(inner);
      container.appendChild(backdrop);
      document.body.appendChild(container);
    }
  }

  openLightbox() {
    // clear and inject fresh content
    this.lightboxContentInner.innerHTML = this.generateGalleryContent(
      this.carouselEnabled ? this.element : this.element.parentNode,
      this.options.carousel
    );

    if (this.options.carousel && this.carouselEnabled) {
      const carouselEl = this.lightboxContentInner.querySelector('.farlo-ui-revolver-carousel');
      if (carouselEl) {
        this.carousel = new FarloUiRevolverCarousel(carouselEl, {
          initialIndex: this.currentCarouselIndex
        });
      }
    }

    this.lightbox.classList.add('farlo-ui-lightbox--active');
    this.lightbox.focus();
  }

  closeLightbox() {
    this.lightbox.classList.remove('farlo-ui-lightbox--active');
    // ⚠️ NOTE: we no longer clear innerHTML here,
    // so footer.js will always find its target element.
    setTimeout(() => this.element.focus(), 300);
  }

  handleKeydown(e) {
    if (
      this.lightbox.classList.contains('farlo-ui-lightbox--active') &&
      (e.key === 'Escape' || e.key === 'Esc')
    ) {
      this.closeLightbox();
    }
  }

  onClickOutside(e) {
    if (
      this.lightbox.classList.contains('farlo-ui-lightbox--active') &&
      !this.lightboxContentInner.contains(e.target)
    ) {
      this.closeLightbox();
    }
  }

  generateGalleryContent(root, isCarousel) {
    if (!isCarousel) return root.innerHTML;
    let html = '<div class="farlo-ui-revolver-carousel">';
    Array.from(root.children).forEach(item => {
      html += `
        <div class="farlo-ui-revolver-carousel__chamber">
          ${item.innerHTML}
        </div>
      `;
    });
    html += '</div>';
    return html;
  }
}

export default FarloUiLightbox;